// src/modules/games/hooks/useClassrooms.js
import { useState, useEffect } from "react";
import axios from "axios";
// FIX: Changed relative path to useAuth
import useAuth from "../../auth/hooks/useAuth"; 

const useClassrooms = () => {
  const [classrooms, setClassrooms] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { state: authState } = useAuth(); 

  useEffect(() => {
    // Basic check for token/auth state
    if (!authState || !authState.access_token) {
        setIsLoading(false);
        setError("Authentication token missing.");
        return;
    }

    const fetchClassrooms = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        // Use the endpoint derived from your Unity code: "duels/classrooms"
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API}/duels/classrooms`,
          headers: {
            Authorization: `Bearer ${authState.access_token}`
          }
        });
        
        // Assuming the response.data contains the { classrooms: [...] } structure
        setClassrooms(response.data); 
        setIsLoading(false);

      } catch (e) {
        console.error("Error fetching duels classrooms:", e);
        setError(e.message || "Failed to fetch classrooms.");
        setIsLoading(false);
      }
    };

    fetchClassrooms();
  }, [authState]);

  return { classrooms, isLoading, error };
};

export default useClassrooms;